import { cn } from "design-system/utils"
import { Loader2 } from "lucide-react"
import { useTranslation } from "react-i18next"

type LoadingProps = {
  minimal?: boolean
  className?: string
  size?: number
}

export function Loading({ minimal, className, size = 4 }: LoadingProps) {
  const { t } = useTranslation()

  return (
    <div
      className={cn(
        "flex flex-row flex-none gap-2 items-center justify-center",
        !minimal && "p-8",
        className,
      )}
    >
      <Loader2
        className={cn(`animate-spin text-muted-foreground`, `size-${size}`)}
        aria-label={t("shared.loading")}
      />
    </div>
  )
}
